<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">

    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">BROKERS</li>
            </ol>
        </nav>
    </div>
    <div class="ms-auto">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" (click)="addbrokerAccount()">ADD</button>
        </div>
    </div>
</div>
<!--end breadcrumb-->

<div class="card">
    <div class="card-body">
        <div class="col-md-3" *ngIf="admin">
            <select class="form-select" [(ngModel)]="filter_params.user" (change)="onUserChanged()" [ngModelOptions]="{standalone: true}">
                <option *ngFor="let u of users" [value]="u._id"> {{ u.full_name }}</option>
            </select>
        </div>
        <div class="table-responsive mt-3">
            <table class="table align-middle">
                <thead class="table-secondary">
                    <tr>
                        <th scope="col">Broker Name</th>
                        <th scope="col">Client ID</th>
                        <th scope="col">Valid Upto</th>
                        <th scope="col" *ngIf="admin">Funds</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ba of broker_accounts" ng-if="broker_accounts.length > 0">
                        <td>{{ getBrokerDnameByName(ba.name) }}</td>
                        <td>{{ ba.params.client_id }}</td>
                        <td>{{ ba.subscription_upto }}</td>
                        <td *ngIf="admin">
                            <a href="javascript:void(0)" *ngIf="!ba.funds_shown" (click)="showFundsClicked(ba)">Show</a>
                            <label *ngIf="ba.funds_shown">{{ ba.funds }}</label>
                        </td>
                        <td>
                            <i class="bi bi-pencil-fill text-success pencil-icon" (click)="updateBrokerAccount(ba)" title="Update Credentials"></i>&nbsp;
                            <i class="bi bi-trash text-danger trash-icon" (click)="deleteBrokerAccount(ba)" title="Delete"></i>&nbsp;
                            <i class="bi bi-card-checklist text-success cc-icon" (click)="checkBrokerConnection(ba)" title="Connect Broker"></i>&nbsp;
                        </td>
                    </tr>
                    <tr *ngIf="broker_accounts.length == 0">
                        <td colspan="4" class="col-md-12 text-center">No Brokers Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<div class="modal fade" data-backdrop="static" data-keyboard="false" id="brokerModal" tabindex="-1" role="dialog" aria-labelledby="brokerModalabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="brokerModalLabel">{{ save_broker_params.header }}</h5>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body px-5">
                <div class="row sub-header-buffer">
                    <div class="col-md-6">
                        <label class="form-label">BROKER</label>
                        <select class="form-select" [(ngModel)]="save_broker_params.broker_name" (change)="onBrokerChanged()" [ngModelOptions]="{standalone: true}">
                            <option *ngFor="let b of brokers" [value]="b._id"> {{ b.display_name }}</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">APP ID</label>
                        <div class="input-group">
                            <input type="{{save_broker_params.app_id_type}}" class="form-control" [(ngModel)]="save_broker_params.app_id">
                            <div class="input-group-append" *ngIf="save_broker_params.mode == 'edit'">
                                <span (click)="toggleShowPassword('app_id')" class="bi eye-icon" [ngClass]="save_broker_params.app_id_class"></span>
                            </div>
                        </div>
                        <div class="invalid-feedback" [ngClass]="valueClass(save_broker_params, 'app_id')">
                            App ID should not be empty.
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div [ngClass]="save_broker_params.client_id_class">
                        <label class="form-label">CLIENT ID</label>
                        <div class="form-group">
                            <input type="text" autocomplete="off" class="form-control" [(ngModel)]="save_broker_params.client_id" />
                        </div>
                        <div class="invalid-feedback" [ngClass]="valueClass(save_broker_params, 'client_id')">
                            Client ID should not be empty.
                        </div>
                    </div>
                    <div [ngClass]="save_broker_params.client_id_class" *ngIf="admin">
                        <label class="form-label">Login</label>
                        <select class="form-select" [(ngModel)]="save_broker_params.login_type" (change)="onLoginTypeChanged()" [ngModelOptions]="{standalone: true}">
                            <option *ngFor="let t of lts" [value]="t._id"> {{ t.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">CLIENT SECRET</label>
                        <div class="input-group">
                            <input type="{{ save_broker_params.cs_type }}" class="form-control" autocomplete="off" [(ngModel)]="save_broker_params.client_secret" />
                            <div class="input-group-append" *ngIf="save_broker_params.mode == 'edit'">
                                <span (click)="toggleShowPassword('cs')" class="bi eye-icon" [ngClass]="save_broker_params.cs_class"></span>
                            </div>
                        </div>
                        <div class="invalid-feedback" [ngClass]="valueClass(save_broker_params, 'client_secret')">
                            Client Secret should not be empty.
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-md-4" *ngIf="admin">
                        <label class="form-label">PASSWORD</label>
                        <div class="input-group">
                            <input type="{{ save_broker_params.pwd_type }}" class="form-control" autocomplete="new-password" [(ngModel)]="save_broker_params.password" />
                            <div class="input-group-append" *ngIf="save_broker_params.mode == 'edit'">
                                <span (click)="toggleShowPassword('pwd')" class="bi eye-icon" [ngClass]="save_broker_params.pwd_class"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4" *ngIf="admin">
                        <label class="form-label">Year of Birth</label>
                        <div class="input-group">
                            <input type="{{ save_broker_params.t_fa_type }}" class="form-control" autocomplete="off" [(ngModel)]="save_broker_params.t_fa" />
                            <div class="input-group-append" *ngIf="save_broker_params.mode == 'edit'">
                                <span (click)="toggleShowPassword('t_fa')" class="bi eye-icon" [ngClass]="save_broker_params.t_fa_class"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4" *ngIf="admin">
                        <label class="form-label">Valid Upto</label>
                        <div class="form-group">
                            <input type="date" class="form-control" autocomplete="off" [(ngModel)]="save_broker_params.valid_upto" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary" (click)="saveBroker()" [disabled]="!valid_params()">
          {{ save_broker_params.button_text }}
        </button>
            </div>
        </div>
    </div>
</div>

<div id="brokerDeleteConfirmationModal" class="modal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ALERT</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="deleteBroker(0)"></button>
        </div>
        <div class="modal-body">
          <p>Are you sure want to delete this broker?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="deleteBroker(0)">Close</button>
          <button type="button" class="btn btn-danger" (click)="deleteBroker(1)">Delete</button>
        </div>
      </div>
    </div>
</div>
